module.exports = __webpack_public_path__ + "static/media/csv-upload.4869cd08.svg";